import {
  SegmentedGroup,
  SegmentedGroupItem,
} from '@repo/ui/components/segmented-group'
import { useTranslate } from '../../hooks'
import type { AdvancedTradeBoxTabsProps } from './advanced-trade-box.types'
import { cn } from '@repo/ui/lib/utils'
import { FeatureFlag } from '../../components'

export const AdvancedTradeBoxTabs = ({
  tab,
  onTabChange,
}: AdvancedTradeBoxTabsProps) => {
  const { t } = useTranslate()
  return (
    <SegmentedGroup
      value={tab}
      onValueChange={onTabChange}
      size='lg'
      className='w-full'
      noIndicatorBg={true}
    >
      <FeatureFlag flagKey={['advanced-trade', 'value', 'buy']}>
        <SegmentedGroupItem
          value='buy'
          className={cn(
            'basis-[calc(50%_+_8px)] text-center text-sm p-sm rounded-md',
            {
              '!filter-none pl-[16px] !bg-positive-main !text-positive-main-100 !font-normal rtl:!rounded-bl-none ltr:!rounded-br-none rtl:!rounded-tl-none ltr:!rounded-tr-none  rtl:[clip-path:polygon(8px_0,_100%_0,_100%_100%,_0_100%)] ltr:[clip-path:polygon(0_0,_100%_0,_calc(100%_-_8px)_100%,_0_100%)]':
                tab === 'buy',
              '!text-neutral-surface-100 basis-[50%] bg-neutral-surface-dark':
                tab === 'sell',
            },
          )}
        >
          {t('order_buy')}
        </SegmentedGroupItem>
      </FeatureFlag>
      <FeatureFlag flagKey={['advanced-trade', 'value', 'sell']}>
        <SegmentedGroupItem
          value='sell'
          className={cn(
            'basis-[calc(50%_+_8px)] text-center text-sm p-sm rounded-md',
            {
              '!filter-none pr-[16px] !bg-negative-main !text-negative-main-100 !font-normal rtl:!rounded-br-none ltr:!rounded-bl-none rtl:!rounded-tr-none ltr:!rounded-tl-none rtl:[clip-path:polygon(0_0,_100%_0,_calc(100%_-_8px)_100%,_0_100%)] ltr:[clip-path:polygon(8px_0,_100%_0,_100%_100%,_0_100%)]':
                tab === 'sell',
              '!text-neutral-surface-100 basis-[50%] bg-neutral-surface-dark':
                tab === 'buy',
            },
          )}
        >
          {t('order_sell')}
        </SegmentedGroupItem>
      </FeatureFlag>
    </SegmentedGroup>
  )
}
